// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__NN828","header":"ClearentDisclaimer_header__1Sv7-","inner":"ClearentDisclaimer_inner__1eb8G"};